import NewToMedicare from '@components/pages/new-to-medicare';

export default NewToMedicare;
